/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type ImportParticipantInRole = typeof ImportParticipantInRole[keyof typeof ImportParticipantInRole] | null;


export const ImportParticipantInRole = {
  interviewer: 'interviewer',
  candidate: 'candidate',
  client: 'client',
  reference: 'reference',
  other: 'other',
} as const;
